import magnifiAPIInstance from "./apiInstance";

export const flpListAPIs = {
  getFtpList: ({ payload }) => magnifiAPIInstance.post(`/list_ftp`, payload),
  ftpPublish: ({ payload }) => magnifiAPIInstance.post(`/publish_to_ftp`, payload),
};
